import { takeLatest, call, put } from 'redux-saga/effects';

import { request } from './api';
import { CUSTOMER_EVENTS, EVENT_BY_ID_BASIC_FIELDS } from '../queries';
import {
  FETCH_CUSTOMER_EVENTS,
  GET_ALL_CUSTOMER_EVENTS,
  FETCH_CUSTOMER_EVENT,
  GET_CUSTOMER_EVENT,
  FETCH_EVENT_CROSS_SELL,
  GET_EVENT_CROSS_SELL,
} from '../constants/action-types';
import { client } from '../modules/apollo';

interface FetchEventsAction {
  userId: string;
  type: string;
  eventState?: string;
}

interface EventsResponse {
  data: {
    events: Event[];
  };
}

function* fetchEvents({
  userId,
  eventState,
}: FetchEventsAction): Generator<any, void, any> {
  yield put({
    type: FETCH_CUSTOMER_EVENT,
    payload: { userId },
  });

  const variables = {
    filter: {
      ...(eventState && { state: { equals: eventState } }),
    },
  };

  try {
    const response: EventsResponse = yield call(client.query, {
      query: CUSTOMER_EVENTS,
      variables,
      fetchPolicy: 'network-only',
    });

    yield put({
      type: FETCH_CUSTOMER_EVENTS,
      payload: response.data.events,
    });
  } catch (err) {
    yield put({
      type: FETCH_CUSTOMER_EVENTS,
      payload: err.response,
    });
  }
}

interface FetchEventAction {
  eventId: string;
  type: string;
  eventState?: string;
}

interface EventResponse {
  data: {
    event: Event;
  };
}

function* fetchEvent({
  eventId,
  eventState,
}: FetchEventAction): Generator<any, void, any> {
  yield put({
    type: FETCH_CUSTOMER_EVENT,
    payload: { eventId },
  });

  const variables = {
    filter: {
      ...(eventId && { eventId }),
      ...(eventState && { state: { equals: eventState } }),
    },
  };

  try {
    const response: EventResponse = yield call(client.query, {
      query: EVENT_BY_ID_BASIC_FIELDS,
      variables,
      fetchPolicy: 'network-only',
    });

    yield put({
      type: FETCH_CUSTOMER_EVENT,
      payload: response.data.event,
    });
  } catch (err) {
    yield put({
      type: FETCH_CUSTOMER_EVENT,
      payload: err.response,
    });
  }
}

function* fetchEventCrossSell({ eventId }) {
  // @ts-ignore
  const crossSell = yield call(request, {
    url: `/events/${eventId}/cross-sell`,
    method: 'GET',
  });

  yield put({
    type: FETCH_EVENT_CROSS_SELL,
    payload: crossSell,
  });
}

export default function* customerEventsSaga() {
  yield takeLatest(GET_ALL_CUSTOMER_EVENTS, fetchEvents);
  yield takeLatest(GET_CUSTOMER_EVENT, fetchEvent);
  // @ts-ignore
  yield takeLatest(GET_EVENT_CROSS_SELL, fetchEventCrossSell);
}
